// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__c0PuH","col":"CardReaderDesc_col__3bZ2t","label":"CardReaderDesc_label__3O-Ls"};